import { useFormType } from "../../form/hooks/useForm";
import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../../types/EntityConfig";
import { PecasTableConfig } from "../Peças/Pecas.config";


export const ObrasTableConfigs : EntityConfig = [
    {
      id: 'id',
      label: 'Id',
      type: "id",
      nonEditable: true
    },
      {
      id: 'client',
      label: 'Cliente',
      type: 'select',
      routable: true,
      filterable: true,
      options: {
        name: 'Cliente',
        route: 'clients',
        value: 'id',
        label: 'name',
        getter: ()=>genericGet('/findByFilter/clientes'),
        searcheable: true

      }
    },
    {
      id: 'number',
      label: 'Nº Obra',
      type: "text",
      filterable: true
    },
    {
      id: 'orcamentos',
      label: 'Orçamentos',
      type: 'multi-select',
      routable: true,
      options: {
        name: 'Orçamento',
        route: 'orcamentos',
        value: 'id',
        label: 'billCode',
        triggeredGetter: (i: any)=>genericGet(`/orcamentos/client/${i}`), // function to trigger according to other form parameter
        triggerParam: 'client', // Form parameter used to build getterfunction
        searcheable: true

      },
      separateValueUpdateOptions: {
        inputField: 'valueWithIVA',
        outputField: 'value',
        operation: 'sum',
      }
    },
    {
      id: 'value',
      label: 'Valor da Obra',
      type: 'number',
      displayInfo: 'currency'
    },
    {
      id: 'orderNote',
      type: 'text',
      filterable: true,
      label: 'Nota Encomenda',
    },
    {
        id: 'partAmount',
        label: 'Qnt. Peças',
        type: 'number'
    },
    
    {
      id: 'machines',
        subProp: 'ref',
        label: 'Máquinas',
        type: 'multi-select',
        routable: true,
        options: {
          name: 'Máquina',
          route: 'machines',
          value: 'id',
          label: 'ref',
          getter: ()=>genericGet('/findByFilter/maquinas'),
          searcheable: true,
        },
        separateValueUpdateOptions: {
          operation: (obj: any, state: any)=> {  
            if(!obj['machines'] || !obj['machines'].length) {
              obj['overallDuration'] = 0;
              return;
            }
            const value = state['value'];
            const machineProd = obj['machines'].reduce((p : any,c : any) => p + c['production'], 0);            
            const totalProduction = (value / machineProd) * 8;
            obj['overallDuration'] = totalProduction;
          },
        }
    },
    {
      id: 'overallDuration',
      label: 'Duração total (h)',
      type: 'number'
  },
  { 
    id: 'bills',
    label: 'Faturas',
    type: 'multi-select',
    nonEditable: true,
    routable: true,
    options: {
      name: 'Fatura cliente',
      route: 'faturacao-clientes',
      value: 'id',
      label: 'code',
    },
    },
    { 
      id: 'entregas',
      label: 'Datas reais de entrega',
      type: 'multi-select',
      nonEditable: true,
      options: {
        value: 'id',
        label: 'realDeliveryDate'
      }
    },
    {
      id: 'entregas',
      label: 'Datas de expedição',
      type: 'multi-select',
      nonEditable: true,
      options: {
        deeplyNestedValue: (value : any) => {
          const entregas = value.value;
          const pecasParaEntrega = entregas.filter((entrega: any) => entrega.pecasParaEntrega.length > 0).flatMap((entrega: any) => entrega.pecasParaEntrega); 
          const expedicoes = pecasParaEntrega.filter((peca: any) => peca.expedicoes.length > 0).flatMap((peca: any) => peca.expedicoes);
          if(expedicoes.length == 0) return;
          const datas = expedicoes.map((e: any) => e.data? e.data.split('T')[0] : null).filter((d: any) => d);
          if(datas.length == 0) return;
          return datas.join(', ');
        }
      }
    },
    {
      id: 'state',
      label: 'Estado',
      type: 'enum',
      filterable: true,
      options: {
        route: 'state',
        getter: ()=>genericGet('/obras/states/options'),
      }
  },
  {
    id: 'pecas',
    label: 'Pecas',
    type: 'multiple-create',
    hideColumn: true,
    options: {
      name: 'Peças',
      route: 'pecas',
      ref: 'pecas',
      value: 'id',
      label: 'reference',
      subFormConfig: PecasTableConfig,
      nestPathGetter: (form: useFormType | undefined, i: number) => form?.state['pecas'][i]
    }
  }


 
  ];
  